module.exports = __webpack_public_path__ + "static/media/19ESCAP51.3464a363.jpg";